// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISortOrder
 */
export interface ISortOrder {
    /**
     * 
     * @type {string}
     * @memberof ISortOrder
     */
    direction?: ISortOrderDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ISortOrder
     */
    property?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ISortOrder
     */
    ignore_case?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ISortOrder
     */
    null_handling?: ISortOrderNullHandlingEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ISortOrder
     */
    ascending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ISortOrder
     */
    descending?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum ISortOrderDirectionEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}
/**
* @export
* @enum {string}
*/
export enum ISortOrderNullHandlingEnum {
    NATIVE = 'NATIVE',
    NULLS_FIRST = 'NULLS_FIRST',
    NULLS_LAST = 'NULLS_LAST'
}


/**
 * Check if a given object implements the ISortOrder interface.
 */
export function instanceOfISortOrder(value: object): value is ISortOrder {
    return true;
}

export function ISortOrderFromJSON(json: any): ISortOrder {
    return ISortOrderFromJSONTyped(json, false);
}

export function ISortOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISortOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'direction': json['direction'] == null ? undefined : json['direction'],
        'property': json['property'] == null ? undefined : json['property'],
        'ignore_case': json['ignoreCase'] == null ? undefined : json['ignoreCase'],
        'null_handling': json['nullHandling'] == null ? undefined : json['nullHandling'],
        'ascending': json['ascending'] == null ? undefined : json['ascending'],
        'descending': json['descending'] == null ? undefined : json['descending'],
    };
}

export function ISortOrderToJSON(json: any): ISortOrder {
    return ISortOrderToJSONTyped(json, false);
}

export function ISortOrderToJSONTyped(value?: ISortOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'direction': value['direction'],
        'property': value['property'],
        'ignoreCase': value['ignore_case'],
        'nullHandling': value['null_handling'],
        'ascending': value['ascending'],
        'descending': value['descending'],
    };
}

